module.exports = __webpack_public_path__ + "media/images/symbols/instagram-white-b2580d174bb273f1aa77b610df8d5870.svg";